import { Row, Space, Spinner } from "@masterteam/mt-design-react";
import sortBy from "lodash/sortBy";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Breadcrumb from "../Breadcrumb";
import ListsContainer from "../ListsContainer";
import InfoCards from "./InfoCards";
import ObjectiveTitle from "./ObjectiveTitle";

import { addToast } from "../../helpers";
import api from "../../providers/api";

import "./style.scss";

function ObjectiveDetails({ match }) {
  const [objective, setObjective] = useState({});
  const [dataLoading, setDataLoading] = useState(true);
  const [kpisStatus, setKpisStatus] = useState([]);
  const [projectsStatus, setProjectsStatus] = useState([]);
  const [systemStatus, setSystemStatus] = useState([]);
  const [kpisTypes, setKpisTypes] = useState([]);
  const [orgStructure, setOrgStructure] = useState([]);
  const [initiativeStatus, setInitiativeStatus] = useState([]);

  const objectiveLevels = useSelector(
    (store) => store.theme.ObjectiveLevel.item.Items
  );

  async function getData() {
    setDataLoading(true);

    try {
      const [
        resStatuses,
        resProjectsStatuses,
        resTypes,
        dataRes,
        orgStructureRes,
        systemStatusesRes,
        initiativeStatusRes
      ] = await Promise.all([
        api.handshake.getKPIStatuses(),
        api.handshake.getProjectStatuses(),
        api.kpiType.getAll(),
        api.strategyMap.getObjectiveByID(match.params.id),
        api.orgStructure.getAllTree(),
        api.handshake.getSystemStatuses(),
        api.initiatives.initiativeStatuses()
      ]);
      setKpisStatus(resStatuses.Data ? sortBy(resStatuses.Data, "Order") : []);
      setProjectsStatus(
        resProjectsStatuses.Data
          ? sortBy(resProjectsStatuses.Data, "Order")
          : []
      );
      setSystemStatus(systemStatusesRes.Data || []);
      setKpisTypes(resTypes.Data || []);
      setObjective(dataRes.Data);
      setOrgStructure(orgStructureRes?.Data || []);
      setInitiativeStatus(initiativeStatusRes?.Data || []);
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error"
      });
    } finally {
      setDataLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, [match.params.id]);

  const parentKey = +objective?.StrategyType === 1 ? "Theme" : "Pillar";

  const level = objectiveLevels?.find((e) => +e?.Value === +objective?.Level);

  let breadcrumbData = [
    {
      ...objective?.[parentKey]?.Strategy,
      path: `/splus/strategy-map/${objective?.[parentKey]?.Strategy?.ID}`
    },
    objective?.[parentKey],
    // { ArabicName: level?.Arabic, EnglishName: level?.English }, // Level
    objective
  ];
  const isSupportive = objective?.StrategyType === 2;
  if (objective?.ParentID)
    breadcrumbData.splice(2, 0, {
      ...objective.ObjectiveParent,
      path: `/splus/objective-details/${objective?.ObjectiveParent?.ID}`
    });

  return (
    <Space direction="vertical" size="large" className="objective-container">
      {dataLoading ? (
        <div className="loader-container">
          <Spinner size="large" />
        </div>
      ) : (
        <div>
          <Row className="objective-container__header">
            <Breadcrumb data={breadcrumbData} fontSize="var(--font-large)" />
          </Row>

          <Space
            direction="vertical"
            size="large"
            className="objective-container__content"
          >
            <ObjectiveTitle
              objective={objective}
              parentKey={parentKey}
              statuses={systemStatus}
            />

            <InfoCards
              objective={objective}
              kpisStatus={kpisStatus}
              projectStatuses={isSupportive ? initiativeStatus : projectsStatus}
              isSupportive={isSupportive}
            />

            <ListsContainer
              kpiStatuses={kpisStatus}
              projectStatuses={isSupportive ? initiativeStatus : projectsStatus}
              allProjectStatuses={projectsStatus}
              kpiTypes={kpisTypes}
              objective={objective}
              orgStructure={orgStructure}
              isSupportive={isSupportive}
            />
          </Space>
        </div>
      )}
    </Space>
  );
}

export default ObjectiveDetails;
